import * as React from "react";
import { connect } from "react-redux";
import { getVendors } from "../../app/store/actions/whFinanceActions";
import { useNavigate } from "react-router-dom";
import { FoCard, FoSearch, FoTable } from "./financeUi";

const getVendorBrandName = (record) =>
  record?.brandName || record?.name || record?.vendor?.name || "";

export const Vendors = ({
  getVendors,
  vendors,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [brandFilter, setBrandFilter] = React.useState("");

  React.useEffect(() => {
    getVendors();
  }, [getVendors]);

  const filteredVendors = React.useMemo(() => {
    const list = Array.isArray(vendors) ? vendors : [];
    const query = brandFilter.trim().toLowerCase();
    if (!query) return list;
    return list.filter((vendor) =>
      getVendorBrandName(vendor).toLowerCase().includes(query)
    );
  }, [vendors, brandFilter]);

  const vendorColumns = [
    {
      title: "Brand",
      key: "brandName",
      render: (_, record) => getVendorBrandName(record) || "N/A",
      sorter: (a, b) =>
        getVendorBrandName(a).localeCompare(getVendorBrandName(b)),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name || record.vendor?.name || "N/A",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => text || "N/A",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (text) => text || "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <button
          type="button"
          className="fo-btn"
          onClick={() => navigate(`/warehousing/finance/vendors/${record._id}`)}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <div className="fo-stack">
      <div className="fo-tools">
        <FoSearch value={brandFilter} onChange={setBrandFilter} placeholder="Search vendor..." />
      </div>
      <FoCard title="Vendor management" count={`${filteredVendors.length} vendors`}>
        <FoTable
          columns={vendorColumns}
          dataSource={filteredVendors}
          loading={isLoading}
          rowKey={(row) => row._id}
          empty={brandFilter.trim() ? "No vendors match that brand name." : "No vendors found."}
          pagination={{ pageSize: 10, total: filteredVendors.length }}
        />
      </FoCard>
    </div>
  );
};

const mapStateToProps = (state) => ({
  vendors: state?.records?.vendors,
  isLoading: state?.records?.isLoading,
});

const mapDispatchToProps = { getVendors };

export default connect(mapStateToProps, mapDispatchToProps)(Vendors);
